import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-recruiter-create",
  templateUrl: "./recruiter-create.component.html",
  styleUrls: ["./recruiter-create.component.scss"],
})
export class RecruiterCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http.get<any>(this.api_endpoint + "/recruiter/" + `${id}`).subscribe(
        (data) => {
          if (data.data != null) {
            this.action = "Update";
            this.Form.patchValue({
              _id: data.data._id,
              image: data.data.image,
              title: data.data.title,
              subTitle: data.data.subTitle,
            });
          }
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    });

    this.Form = this.formBuilder.group({
      image: ["", Validators.required],
      title: ["", Validators.required],
      subTitle: [""],
      _id: [""],
    });
  }

  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    const formData = {
      image: this.Form.value.image,
      title: this.Form.value.title,
      subTitle: this.Form.value.subTitle,
      _id: this.Form.value._id,
    };

    if (this.action == "Submit") {
      delete formData._id;
      this.http.post<any>(this.api_endpoint + "/recruiter", formData).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/recruiter/list-recruiter");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    } else {
      this.http.put<any>(this.api_endpoint + "/recruiter/", formData).subscribe(
        (res) => {
          console.log(res);
          if (res.Error) {
            this.message = res.Error;
            this.class = "btn btn-primary";
            return;
          } else {
            this.message = "Successfully Added";
            this.class = "btn btn-success";
          }
          this.router.navigateByUrl("/adminhkbkcms/recruiter/list-recruiter");
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
    }
  }
}
